import React, {FC, Key, ReactNode} from 'react'

type ChannelSettingSequencePairProps = {
  order: number
  pairKey: Key
  left: ReactNode
  right: ReactNode
}

/** Two independent half-row columns in one pair row (staging col-sm-6 model). */
const ChannelSettingSequencePair: FC<ChannelSettingSequencePairProps> = ({
  order,
  pairKey,
  left,
  right,
}) => (
  <div
    key={pairKey}
    className='col-12 mt-4 channel-setting-sequence-pair'
    style={{order}}
  >
    <div className='channel-setting-sequence-pair__left'>{left}</div>
    <div className='channel-setting-sequence-pair__right'>{right}</div>
  </div>
)

export default ChannelSettingSequencePair
